import { CartLinesUpdateEvent } from '@shopify/events';
const routes = (window.Theme && window.Theme.routes) || {};
const ADD_URL = routes.cart_add_url || '/cart/add.js';
const CART_URL = (routes.cart_url || '/cart') + '.js';
function cartSectionIds() {
return Array.from(document.querySelectorAll('cart-items-component'))
.map((el) => el instanceof HTMLElement && el.dataset.sectionId)
.filter(Boolean);
}
async function addToCart(button) {
const variantId = button.dataset.variantId;
if (!variantId || button.classList.contains('is-loading')) return;
const quantity = Number(button.dataset.quantity || 1);
const sections = cartSectionIds();
const deferred = CartLinesUpdateEvent.createPromise();
button.classList.add('is-loading');
button.setAttribute('aria-busy', 'true');
button.dispatchEvent(
new CartLinesUpdateEvent({
action: 'add',
context: 'product',
lines: [{ merchandiseId: String(variantId), quantity }],
promise: deferred.promise,
})
);
try {
const body = { items: [{ id: Number(variantId), quantity }] };
if (sections.length) body.sections = sections.join(',');
const res = await fetch(ADD_URL, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify(body),
});
const data = await res.json();
const cart = await fetch(CART_URL, { headers: { Accept: 'application/json' } }).then((r) => r.json());
deferred.resolve({
cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
detail: {
items: cart.items,
source: 'nbp-quick-add',
sourceId: button.id || 'nbp-quick-add',
itemCount: quantity,
productId: button.dataset.productId,
sections: data.sections,
didError: Boolean(data.status),
},
});
if (data.status) throw new Error(data.description || data.message || 'Could not add to cart');
button.classList.add('is-added');
setTimeout(() => button.classList.remove('is-added'), 1800);
const drawer = document.querySelector('#cart-drawer');
if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) {
setTimeout(() => drawer.open(), 150);
} else if (!drawer) {
window.location.href = routes.cart_url || '/cart';
}
} catch (error) {
deferred.reject?.(error);
console.warn('[nbp-quick-add]', error);
const msg = button.closest('[data-nbp-card]')?.querySelector('[data-nbp-card-error]');
if (msg) {
msg.textContent = error.message;
msg.hidden = false;
setTimeout(() => (msg.hidden = true), 4000);
}
} finally {
button.classList.remove('is-loading');
button.removeAttribute('aria-busy');
}
}
document.addEventListener('click', (event) => {
const button = event.target instanceof Element ? event.target.closest('[data-nbp-quick-add]') : null;
if (!button) return;
event.preventDefault();
addToCart(button);
});